export const FETCH_ARTICLE_BY_ID_REQUEST = 'FETCH_ARTICLE_BY_ID_REQUEST';
export const FETCH_ARTICLE_BY_ID_SUCCESS = 'FETCH_ARTICLE_BY_ID_SUCCESS';
export const FETCH_ARTICLE_BY_ID_FAILURE = 'FETCH_ARTICLE_BY_ID_FAILURE';
export const FETCH_ARTICLE_CLEAN_UP = 'FETCH_ARTICLE_CLEAN_UP';
